import React from 'react'
import { useIntl } from 'gatsby-plugin-intl'

import Layout from 'components/layout'
import MetaTags from 'components/MetaTags'
import Header from 'components/Header'

import styled from 'styled-components'

import { media } from 'styles/media'
import { greyLight } from 'styles/colors'
import * as spacing from 'styles/spacing'

import Heading from 'components/Heading'
import List from 'components/List'
import Section, { SectionBlock } from 'components/Section'
import Wrapper from 'components/Wrapper'
import GridRow from 'components/grid/GridRow'
import GridItem from 'components/grid/GridItem'
import BookButton from 'components/button/BookButton'
import Button from 'components/button/Button'
import ProseSegments from 'components/ProseSegments'

import offersContent from 'content/offersContent.json'
import { offerAltPath } from 'content/docAlternatePaths'

function findOffer(locale, slug) {
  for (const cat of offersContent[locale] || []) {
    const o = (cat.offers || []).find((x) => x.slug === slug)
    if (o) return o
  }
  return null
}

const Container = styled.div`
  position: static;
`

const Main = styled.main`
  position: static;
  max-width: 700px;

  small {
    display: block;
    color: ${greyLight};
  }

  ${media.medium`
    padding-right: ${spacing.xLarge};
    max-width: none;
  `};

  ${media.large`
    padding-right: ${spacing.xxxLarge};
  `};

  ${media.xLarge`
    padding-right: 88px;
  `};
`

const OfferTemplate = ({ pageContext }) => {
  const intl = useIntl()
  const slug = pageContext.slug
  const offer = findOffer(intl.locale, slug)

  const rawAlt = offerAltPath(intl.locale, slug)
  const pageAlternativeLangPath = rawAlt || undefined

  if (!offer) {
    return (
      <Layout>
        <MetaTags title='Hotel Griffintown' />
        <Wrapper>
          <p>Not found.</p>
        </Wrapper>
      </Layout>
    )
  }

  return (
    <Layout>
      <MetaTags
        title={`${offer.seoTitle} | ${intl.formatMessage({
          id: 'offer',
        })} | Hotel Griffintown`}
        description={offer.seoDescription}
        noindex={offer.hidden || false}
      />

      <Header
        eyebrow={intl.formatMessage({ id: 'offer' })}
        heading={offer.title}
        heroImageUrl={offer.heroImageUrl}
        pageAlternativeLangPath={pageAlternativeLangPath}
      />

      <Container>
        <Section>
          <Wrapper size='narrow'>
            <GridRow>
              <GridItem xs='1-1' md='2-3'>
                <Main>
                  <Heading size={4} variant='sans'>
                    {intl.formatMessage({ id: 'suites.overview' })}
                  </Heading>

                  {offer.body && offer.body.length > 0 ? (
                    <ProseSegments segments={offer.body} />
                  ) : null}

                  <BookButton
                    url={offer.bookingUrl}
                    target={offer.bookingTarget}
                  />
                </Main>
              </GridItem>
              <GridItem xs='1-1' md='1-3'>
                <List items={offer.includes || []} />
              </GridItem>
            </GridRow>
          </Wrapper>
        </Section>
        <Section flushTop>
          <Wrapper>
            <SectionBlock>
              <div
                css={`
                  text-align: center;
                `}
              >
                <Button to='/offers' theme='secondary'>
                  {intl.formatMessage({ id: 'offer.showAll' })}
                </Button>
              </div>
            </SectionBlock>
          </Wrapper>
        </Section>
      </Container>
    </Layout>
  )
}

export default OfferTemplate
